import { IStatus } from './Common';
import { IComponent } from './Component';
import { IComponentType } from './ComponentType';
import { ILayout } from './Layout';
import { ILayoutScreen } from './LayoutScreen';

export interface IAssembly {
  id: number;
  name: string;
  status: IStatus;
  locationAssigned?: string;
  screenSetup?: string;
  channelType?: string;
  created_at: string;
  modified_at: string;
  layout_id?: number;
  layout?: ILayout;
  layoutScreens?: ILayoutScreen[];
  variation_parent_id: number | null;
  assembly_tag_id: number[];
  assemblyTags?: IAssemblyTag[];
  parentAssembly?: Omit<IAssembly, 'parentAssembly'>;
  childrenAssemblies: Omit<IAssembly, 'parentAssembly'>[];
  siblingAssemblies: Omit<IAssembly, 'parentAssembly'>[];
  assemblyComponents?: IAssemblyComponent[];
  components?: IComponent[];
  config?: IAssemblyConfig;
  startDate?: string | null;
  validTo?: string | null;
  columnId?: number | null;
}

export interface IAssemblyConfig {
  layout?: IAssemblyConfigLayout;
}

export interface IAssemblyConfigLayout {
  defaultLayout?: IAssemblyConfigLayoutDuration;
  sectionRotation?: IAssemblyConfigLayoutDuration;
  takeover?: IAssemblyConfigLayoutDuration;
}

interface IAssemblyConfigLayoutDuration {
  duration?: number;
}

export interface IViewAssembly {
  id: number;
  name: string;
  layout_id: number;
  layout?: ILayout;
  status: IStatus;
  created_at: string;
  modified: string;
  parent: IAssembly | null;
  assemblyComponents: IAssemblyComponent[];
  components: IComponent[];
  componentTypes: IComponentType[];
}

export interface IAssemblySearch {
  id: number;
  name: string;
  end_date: string | null;
}

export interface IAssemblyComponent {
  uid: string;
  id: number;
  assembly_id: number;
  layout_screen_id?: number;
  screen_section_id?: number;
  component_id: number;
  allow_overrides?: boolean;
  rotation_order: number;
  backup_order: number;
  duration?: number;
  config?: {
    duration?: number;
    transition: string;
  };
  start_date?: string | null;
  end_date?: string | null;
  status?: IStatus;
  created_at?: string;
  modified_at?: string;
  component?: IComponent;
  narrative?: string;
}

export enum AssemblyState {
  UNUSED = 'unused',
  SCHEDULED = 'scheduled',
  RETIRED = 'retired',
  LIVE = 'live',
  DEFAULT = 'default',
}

export interface IAssemblyTag {
  id: number;
  name: string;
  created_at: string;
  modified_at: string;
}

export interface IAssemblyTagWithAssembliesCount {
  id: number;
  name: string;
  assembly_count: number;
  created_at: string;
  modified_at: string;
}
